import { FC, useEffect, useState } from 'react';
import { DashboardGoalMetPassedOrNotQuery$data } from '../../../graphQLOperations/__generated__/DashboardGoalMetPassedOrNotQuery.graphql';
import CopyListOfStudentsButton from '../CopyListOfStudentsButton';
import { Paginator, PaginatorPageChangeEvent } from 'primereact/paginator';
import { MaskedStudentData } from '../../MaskedData/MaskedStudentData';
import { PiiTypes } from '../../../analytics/dataMasking';

interface Props {
  passedFlag: boolean;
  queryData: DashboardGoalMetPassedOrNotQuery$data;
}

interface StudentData {
  firstName: string;
  lastName: string;
  publicUserId: string;
}

const GoalMetList: FC<Props> = ({ passedFlag, queryData }) => {
  const value = !passedFlag && 'NOT';
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [paginatedData, setPaginatedData] = useState<StudentData[]>([]);

  const onPageChange = (event: PaginatorPageChangeEvent) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const sortByLastNameThenFirstName = (a: StudentData, b: StudentData) =>
    (a.lastName || '').localeCompare(b.lastName || '', undefined, { sensitivity: 'base' }) ||
    (a.firstName || '').localeCompare(b.firstName || '', undefined, { sensitivity: 'base' });

  useEffect(() => {
    if (queryData) {
      let data = queryData.studentSkillGoalsReport;
      data = [...(data as StudentData[])].sort(sortByLastNameThenFirstName);
      const paginatedSlice = data.slice(first, first + rows);
      setPaginatedData(paginatedSlice as StudentData[]);
    }
  }, [queryData, first, rows]);

  return (
    <>
      <div className={`flex flex-column align-items-center ${passedFlag && `xl:pr-7 md:pr-5`}`}>
        <h3 className="xl:text-xl md:text-base text-sm">Students {value} meeting goal</h3>
        {queryData.studentSkillGoalsReport.length > 0 && (
          <CopyListOfStudentsButton
            studentList={[...(queryData.studentSkillGoalsReport as StudentData[])].sort(sortByLastNameThenFirstName)}
          />
        )}
        {paginatedData && (
          <div className="flex flex-column align-items-left">
            <ul className="list-none p-0" style={{ minHeight: '12.5rem' }}>
              {paginatedData.map((student, index) => (
                <li key={index}>
                  <MaskedStudentData
                    type={PiiTypes.FullName}
                    student={student}
                  >{`${student.firstName} ${student.lastName}`}</MaskedStudentData>
                </li>
              ))}
            </ul>
          </div>
        )}
        {queryData.studentSkillGoalsReport.length > 0 && paginatedData && (
          <Paginator
            first={first}
            rows={rows}
            totalRecords={queryData.studentSkillGoalsReport.length}
            className="p-1"
            onPageChange={onPageChange}
            template="PrevPageLink CurrentPageReport NextPageLink"
            prevPageLinkIcon={<i className="nc_icon-nc_left icon-sm mr-2 text-primary cursor-pointer"></i>}
            nextPageLinkIcon={<i className="nc_icon-nc_right icon-sm ml-2 text-primary cursor-pointer"></i>}
            currentPageReportTemplate="{first} to {last} of {totalRecords}"
          />
        )}
      </div>
    </>
  );
};

export default GoalMetList;
